/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
import { Currencies, WalletTypes } from '@constants/enums';
import { useRef } from 'react';
import { IconButton } from '@mui/material';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import { useSelector } from 'react-redux';
import { selectProfileData } from '@pages/profile/store/selectors';
import useEffectOnce from '@main-hooks/useEffectOnce';
import { IWallet } from '../../../../services/client/types';
import { TabsWalletsStyles } from './TabWallets.styles';
import WalletCard from './WalletCard';
import CreateWalletCard from './components/CreateWalletCard';
import useAddWalletTour from './hooks/useAddWalletTour';
import { TAB_GLOBAL_ACCOUNT } from '../wallets/constants';

interface TabsWalletProps {
  data: IWallet[];
  addFunds: (currency: Currencies, walletType?: WalletTypes) => void;
  onConvert: () => void;
  currentTab: number;
}

const ITEMS_PER_PAGE = 3;
const SCROLL_WIDTH = 595;

const TabsWallet = ({
  data,
  addFunds,
  onConvert,
  currentTab,
}: TabsWalletProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const userProfile = useSelector(selectProfileData);
  const { isAwActive } = userProfile || {};
  const isGlobalAccount = (type: WalletTypes) =>
    type === WalletTypes.GLOBAL_ACCOUNT;

  const { startTour } = useAddWalletTour();

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -SCROLL_WIDTH, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: SCROLL_WIDTH, behavior: 'smooth' });
    }
  };

  const handleAddFunds = (currency: Currencies, walletType: WalletTypes) => {
    addFunds(currency, walletType);
  };

  useEffectOnce(() => {
    startTour();
  });

  return (
    <div className="w-full relative">
      <div className={TabsWalletsStyles.wrapper} ref={scrollRef}>
        {data.map((wallet) => (
          <WalletCard
            key={wallet.currency.name}
            wallet={wallet}
            addFunds={handleAddFunds}
            isGlobalAccount={isGlobalAccount(wallet.wallet.wallet_type)}
          />
        ))}
        {isAwActive && currentTab === TAB_GLOBAL_ACCOUNT && (
          <CreateWalletCard
            walletsAleadyActive={data.map((wallet) => wallet.currency.name)}
            onConvert={onConvert}
            addFunds={addFunds}
          />
        )}
      </div>
      {data.length + (isAwActive ? 1 : 0) > ITEMS_PER_PAGE && (
        <>
          <div
            className={`${TabsWalletsStyles.controls} ${TabsWalletsStyles.prevButton}`}
          >
            <IconButton onClick={scrollLeft} aria-label="Previous">
              <ArrowBackIos />
            </IconButton>
          </div>
          <div
            className={`${TabsWalletsStyles.controls} ${TabsWalletsStyles.nextButton}`}
          >
            <IconButton onClick={scrollRight} aria-label="Next">
              <ArrowForwardIos />
            </IconButton>
          </div>
        </>
      )}
    </div>
  );
};

export default TabsWallet;
